import * as flashActions from './flash.actions';
import { Action } from '@ngrx/store';

import { cloneDeep } from 'lodash';
import { AppState } from '../../../app.state';

export interface State {
  readonly name: string; // Determines flash content
  readonly expiresAfter?: number; // Number of milliseconds to show flash
  readonly additionalInfos?: any; // Allow to specify additional infos for each flash custom content (i.e. new email)
}

const initialState: State = {
  name: null,
};

export function flashReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case flashActions.ActionTypes.SHOW:
      return cloneDeep(action.payload);
    case flashActions.ActionTypes.DISMISS:
      return initialState;

    default:
      return state;
  }
}

export const getFlashState = (state: AppState) => state.flash;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/store/flash.reducer.ts